import dayjs from 'dayjs';
import { ITaskCenterFilter } from './types';

export const searchOptions = [{ value: 'status', label: 'STATUS' }];

export const defaultFilter: ITaskCenterFilter = {
	start: dayjs().subtract(30, 'day'),
	end: dayjs(),
	searchOptionType: searchOptions[0].value
};

export enum taskStatus {
	IN_PROGRESS = 'in-progress',
	COMPLETED = 'completed',
	FAILED = 'failed'
}

export const tagColor = {
	[taskStatus.IN_PROGRESS]: 'orange',
	[taskStatus.COMPLETED]: 'green',
	[taskStatus.FAILED]: 'red'
};
